import { IConfigName } from './interface/field-type-object';

interface IDefaultDataObject {
  configName: IConfigName;
  required: boolean;
  type: string;
}

const defaultData: IDefaultDataObject = {
  configName: IConfigName.TextStringMultiline,
  required: false,
  type: 'string',
};

interface IDefaultConfigObject {
  format: string;
  displayType: string;
}

const defaultConfig: IDefaultConfigObject = {
  format: 'none',
  displayType: 'paragraph',
};

const value = {
  title: 'Text String Multiline',
  icon: {
    black: require('../../icons/black/align-justify.png'),
    white: require('../../icons/white/align-justify.png'),
    blue: require('../../icons/blue/align-justify.png'),
  },
  style: {
    width: '17px',
    height: '17px',
    left: '2px',
    top: '1px'
  },
  defaultData,
  defaultConfig
}

export default value;